import { MonitorSmartphone } from 'lucide-react';
import { Modal } from '@/components/ui/Modal/Modal';
import { Button } from '@/components/ui/Button';

export interface MobileSuggestionModalProps {
  open: boolean;
  onClose: () => void;
}

export function MobileSuggestionModal({
  open,
  onClose,
}: MobileSuggestionModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      size="md"
    >
      <div className="flex flex-col gap-4 items-center py-2">
        {/* Icon */}
        <div className="flex items-center justify-center size-8 shrink-0">
          <MonitorSmartphone
            size={32}
            className="text-foreground"
            strokeWidth={1.5}
          />
        </div>

        {/* Text block */}
        <div className="flex flex-col gap-1.5 w-full">
          <p className="text-xl font-medium leading-7 text-foreground">
            Mobile view required
          </p>
          <p className="text-base font-normal leading-6 text-muted-foreground">
            For now, Yaruta works best on mobile. Please switch to your phone to
            continue — desktop view is coming soon.
          </p>
        </div>

        {/* CTA */}
        <Button
          variant="primary"
          size="md"
          className="w-full"
          onClick={onClose}
        >
          Got it
        </Button>
      </div>
    </Modal>
  );
}
